import DEFAULT from '@/config/premadeConfigs'
import premadeSteps from '@/config/premadeConfigs/steps'
import { PartnerConfig } from '@/types'
import { Field } from '@/types/partnerConfig'

const { LOGOS, APPNAMES, FIELDS, FIELD_LISTS } = DEFAULT

const dateOfTravelField: Field = {
  type: 'date',
  name: 'dateOfTravel',
  required: false,
  disabled: false,
  label: 'Date of travel',
  helpText: 'Please confirm the departure date of your next trip',
}

const columbusDirectTemplate: PartnerConfig = {
  branding: {
    logo: [
      LOGOS.BABYLON,
      {
        src: '/images/GBR/columbus-direct.png',
        alt: 'Columbus Direct logo',
      },
    ],
  },
  config: {
    name: 'Columbus Direct',
    appName: APPNAMES.BABYLON,
    acceptLanguage: 'en-GB',
    codes: {
      membership: 'collinson',
    },
    partnerUrlSlug: '', // To be filled by the Columbus Direct partners
    steps: premadeSteps,
    fields: [
      [FIELDS.EMAIL, dateOfTravelField],
      [
        FIELDS.FIRST_NAME,
        FIELDS.LAST_NAME,
        FIELDS.DATE_OF_BIRTH,
        FIELDS.PASSWORD,
        FIELDS.PHONE_COUNTRY_CODE,
        FIELDS.PHONE_NUMBER,
      ],
      FIELD_LISTS.familyMemberFields.GBR,
    ],
  },
  content: {
    'en-GB': {
      steps: [
        {
          title: 'Columbus Direct introduces Babylon - a GP at your fingertips',
          stepperLabel: 'Welcome',
          copy: [
            'Columbus Direct has teamed up with Babylon - an easy to use app that gives you access to healthcare wherever you are in the world.',
            'You can get fast medical advice and have video appointments with English speaking GPs if you feel unwell.',
            'Fill in your details to register with Babylon today.',
          ],
          productFeatures: [
            {
              icon: 'ChatFilled',
              title: 'Check your symptoms quickly and easily',
              description:
                'Check your symptoms instantly to get the most appropriate health information and next steps.',
            },
            {
              icon: 'PeopleMedicalSpecialist',
              title: 'Talk to a doctor, 24/7',
              description:
                'Talk to a doctor at any time of the day or night, directly from your mobile. Appointments are normally available within two hours.',
            },
            {
              icon: 'Medication',
              title: 'Prescriptions sent to a local pharmacy of your choice',
              description:
                'Have a prescription sent electronically to your chosen pharmacy for collection*, or get it delivered free to your home or workplace. *If abroad, available only in specific locations, and subject to the availability of the pharmacy.',
            },
          ],
        },
        {
          title: 'Registration',
          stepperLabel: 'Registration',
          copy: [
            'Babylon just needs a few details from you and then you can enjoy your trip, knowing that a GP and medical advice is only a few clicks away.',
          ],
        },
        {
          title: 'Add Family Members',
          stepperLabel: 'Family',
          copy: [
            'Before you finish, don‘t forget to add any family members covered by your Columbus policy, so they can also have access to expert medical advice while you‘re away.',
          ],
        },
        {
          title: 'You’re all set',
          stepperLabel: 'Thank You',
          copy: [
            'With your Columbus Direct travel insurance policy, you now have access to expert medical advice while you‘re away.',
            'Don‘t forget to download the app for easy access.',
            'Happy travelling!',
          ],
          cta: {
            label: 'Book an appointment',
            webAppPartialLink: '/consultations/new',
            type: 'ButtonLink',
          },
        },
      ],
      footerLinks: DEFAULT.FOOTERLINKS.GBR,
    },
  },
}

export default columbusDirectTemplate
